<div class="top">
  <img [src]="data?.image" alt="loyalty - allstar casino">
  <div class="top__section">
    <div class="top__title">{{data?.name}}</div>
    @if (data.pointsTo) {
      <div class="top__value">{{data?.pointsFrom | number}}-{{data?.pointsTo | number}}</div>
    }
    @if (!data?.pointsTo) {
      <div class="top__value">{{data?.pointsFrom | number}}+</div>
    }
  </div>
</div>
<div class="content" [innerHTML]="data?.bonusMore | safe:'html'"></div>
<div class="action">
  @if (user.auth) {
    <button [routerLink]="['/', lang.current, 'account', 'deposit']" (click)="modal.close()" class="btn small">
      {{'btn.rank-up' | translate}}
    </button>
  } @else {
    <button [routerLink]="['/', lang.current, 'register']" (click)="modal.close()" class="btn small">
      {{'btn.register' | translate}}
    </button>
  }
</div>
